export default __webpack_public_path__ + "static/media/9 1.68c0b55f.svg";